import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'CREATE_ATTACHMENT';

export async function createAttachmentType(
    userToken: string,
    data: Record<string, unknown>,
) {
    try {

        const response = await axios({
            method: 'post',
            url: `${URL}/attachment-types/`,
            data: data,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${userToken}`
            }
        });

        return response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: "Une erreur de la création d'un type de pièce jointe",
            error: error
        });
    }
}
